module.exports = __webpack_public_path__ + "static/babel-ceaa3f4804aedb18c7a526af6bfe8909.svg";